import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d793237438ea355f547f6be40a0d7103.jpg"
          alt="Advantixx consulting background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d]/90 via-[#0d0d0d]/70 to-[#0d0d0d]/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/60 via-transparent to-[#0d0d0d]/30"></div>
      </div>

      {/* Decorative gold line */}
      <div className="absolute right-16 top-1/4 bottom-1/4 w-px bg-gradient-to-b from-transparent via-[#d4af37]/40 to-transparent hidden lg:block"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20">
        <div className="max-w-2xl">
          {/* Label */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-px bg-[#d4af37]"></div>
            <span className="text-[#d4af37] text-xs uppercase tracking-[3px] font-semibold">
              ACHC Certified Consulting
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-[1.05] mb-6">
            ACHC Home Health
            <br />
            <span className="text-[#d4af37]">Accreditation</span>
            <br />
            Made Simple
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-[#b8b8b8] leading-relaxed mb-10 max-w-xl">
            Expert consulting to help your agency achieve, maintain, and pass ACHC accreditation with confidence and speed.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              className="whitespace-nowrap bg-[#d4af37] text-[#0d0d0d] font-bold text-sm px-8 py-4 rounded-full hover:bg-[#f4c430] transition-all duration-300 text-center cursor-pointer"
            >
              Book a Consultation
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap border-2 border-[#d4af37] text-[#d4af37] font-bold text-sm px-8 py-4 rounded-full hover:bg-[#d4af37] hover:text-[#0d0d0d] transition-all duration-300 text-center cursor-pointer"
            >
              Start Your Accreditation
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mt-14 pt-10 border-t border-white/10">
            {[
              { value: '100%', label: 'ACHC Pass Rate' },
              { value: '50+', label: 'Agencies Served' },
              { value: '10+', label: 'Years Experience' },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="text-2xl md:text-3xl font-black text-[#d4af37]">{stat.value}</p>
                <p className="text-xs text-[#888] mt-1 uppercase tracking-wider">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-gradient-to-b from-[#d4af37]/60 to-transparent"></div>
        <i className="ri-arrow-down-line text-[#d4af37]/60 text-sm"></i>
      </div>
    </section>
  );
}
